import React, { useEffect, useRef, useState } from 'react';
import './index.scss';
import MatchControls from './children/MatchControls';
import ComparedTable from './children/ComparedTable';
import NotComparedTable from './children/NotComparedTable';
import TrendFooter from './children/TrendFooter';
import GraphLoader from '../../../../../../../../Components/ContentLoaders/GraphLoader';
import {
    LIST_TYPES,
    PROJECT_COMPARISON_REQUESTS,
    SEARCH_DEBOUNCE_MS,
} from '../../constants';
import { buildProjectComparisonPayload } from '../../utils/buildProjectComparisonPayload';


const ComparisonView = (props) => {
    const [search, setSearch] = useState('');

    const [debouncedSearch, setDebouncedSearch] = useState('');

    useEffect(() => {
        const timer = setTimeout(() => setDebouncedSearch(search.trim()), SEARCH_DEBOUNCE_MS);
        return () => clearTimeout(timer);
    }, [search]);

    // Both lists arrive with the rest of the trend data (see fetchTrendData), so
    // the mount run has nothing to fetch — this view is only ever mounted just
    // after that, or on a toggle that reused what's already in the store. The
    // exception is cached rows narrowed by a search: the box comes back empty
    // on remount, so the rows under it have to be the unsearched ones again.
    const isFirstRun = useRef(true);
    useEffect(() => {
        if (isFirstRun.current) {
            isFirstRun.current = false;
            if (!props.cachedSearchText) return;
        }
        // A list the current filters leave empty can only come back empty from a
        // search, so it isn't asked — see baseListTotal in the reducer.
        const isEmptyList = {
            [LIST_TYPES.COMPARED]: props.isComparedEmpty,
            [LIST_TYPES.NOT_COMPARED]: props.isNotComparedEmpty,
        };

        // Searching is not a new pairing, just a narrower view of it: the
        // section stays up and each table shows its own loading row instead.
        PROJECT_COMPARISON_REQUESTS.forEach(({ listType, size }) => {
            if (isEmptyList[listType]) return;
            props.getProjectComparison(buildProjectComparisonPayload({
                benchmarkFiltersAnalysis: props.benchmarkFiltersAnalysis,
                listType,
                from: 0,
                size,
                searchText: debouncedSearch,
                isInitialFetch: false,
            }));
        });

    }, [debouncedSearch]);

    // The graph loader covers only the very first load — the reducer raises
    // isInitialLoading for that one alone. A search keeps the section on screen
    // (so the search box keeps focus) and each table shows its own
    // "Loading participants…" instead.
    if (props.isInitialLoading) return <GraphLoader height={300} width={600} />;

    return (
        <>
            <MatchControls search={search} onChangeSearch={setSearch} />
            <ComparedTable searchText={debouncedSearch} />
            <NotComparedTable searchText={debouncedSearch} />
            <TrendFooter />
        </>
    );
};

export default ComparisonView;
